import { render, staticRenderFns } from "./Receipt_no.vue?vue&type=template&id=3c48cb21&"
import script from "./Receipt_no.vue?vue&type=script&lang=js&"
export * from "./Receipt_no.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports